/** Countries LY360 serves, with their weekend days and default time zones (no imports: safe to load first). */
export type CountryCode = 'AE' | 'SA' | 'QA' | 'KW' | 'BH' | 'OM' | 'IN';

/** 0 = Sunday ... 6 = Saturday */
export const WEEKEND_DAYS: Record<CountryCode, readonly number[]> = {
  AE: [6, 0],
  SA: [5, 6],
  QA: [5, 6],
  KW: [5, 6],
  BH: [5, 6],
  OM: [5, 6],
  IN: [0],
};

export const DEFAULT_TIMEZONE: Record<CountryCode, string> = {
  AE: 'Asia/Dubai',
  SA: 'Asia/Riyadh',
  QA: 'Asia/Qatar',
  KW: 'Asia/Kuwait',
  BH: 'Asia/Bahrain',
  OM: 'Asia/Muscat',
  IN: 'Asia/Kolkata',
};
